import React from 'react';
import { Cpu, Settings, Shield } from 'lucide-react';

const Features = () => {
  return (
    <section className="features-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="title">Enterprise Feature Architecture</h2>
          <p className="subtitle">A modular system designed to scale with global enterprise requirements.</p>
        </div>

        <div className="features-grid">
          {/* AI Core */}
          <div className="feature-col">
            <div className="col-header">
              <Cpu className="icon" />
              <h3>AI Core</h3>
            </div>
            <ul className="feature-list">
              <li>
                <strong>Semantic Reasoning</strong>
                <p>Deep understanding of technical terminology and intent.</p>
              </li>
              <li>
                <strong>Context Analysis</strong>
                <p>Multi-dimensional analysis of historical ticket relationships.</p>
              </li>
              <li>
                <strong>Pattern Learning</strong>
                <p>Continuous discovery of new emerging technical debt.</p>
              </li>
              <li>
                <strong>Knowledge Graph Engine</strong>
                <p>Dynamic mapping of institutional knowledge and SOPs.</p>
              </li>
            </ul>
          </div>

          {/* Operations Engine */}
          <div className="feature-col">
            <div className="col-header">
              <Settings className="icon" />
              <h3>Operations Engine</h3>
            </div>
            <ul className="feature-list">
              <li>
                <strong>Smart Routing</strong>
                <p>Contextual assignment based on real-time engineer workload.</p>
              </li>
              <li>
                <strong>SLA-Aware Prioritization</strong>
                <p>Dynamic re-ranking of the queue based on business impact.</p>
              </li>
              <li>
                <strong>Automated Resolution</strong>
                <p>Out-of-the-box workflows for common L1/L2 requests.</p>
              </li>
              <li>
                <strong>Escalation Intelligence</strong>
                <p>Graceful handoffs to human agents with full context briefs.</p>
              </li>
            </ul>
          </div>

          {/* Governance & Security */}
          <div className="feature-col">
            <div className="col-header">
              <Shield className="icon" />
              <h3>Governance & Security</h3>
            </div>
            <ul className="feature-list">
              <li>
                <strong>Role-Based Access Control</strong>
                <p>Granular permissions aligned with enterprise IAM.</p>
              </li>
              <li>
                <strong>Full Audit Logs</strong>
                <p>Every AI action is logged for full operational traceability.</p>
              </li>
              <li>
                <strong>Encryption at Rest & Transit</strong>
                <p>Enterprise-grade AES-256 and TLS 1.3 standards.</p>
              </li>
              <li>
                <strong>Enterprise-Grade Security</strong>
                <p>Built with industry-standard security best practices and secure data handling.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
